import React, { Fragment } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import AddCircleIcon from '@mui/icons-material/AddCircle';

function CaseIndependentCooperationWithThePolice() {
  const [numberOfOther, setNumberOfOther] = React.useState<number>(1);

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'block',
        padding: '0px 24px 20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
      }}
    >
      <Grid container mb={2}>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem' fontWeight='bold'>
            8 Fallunabhängige Zusammenarbeit mit der Polizei
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography fontSize='0.9rem' align='right'>
            Anzahl
          </Typography>
        </Grid>
      </Grid>
      <Grid container rowSpacing={2} columnSpacing={4} className='fhbf-print-field-value-border'>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem'>Abstimmungsgespräche</Typography>
        </Grid>
        <Grid item xs={5}>
          <TextField label='' variant='standard' fullWidth />
        </Grid>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem'>Schulungen</Typography>
        </Grid>
        <Grid item xs={5}>
          <TextField label='' variant='standard' fullWidth />
        </Grid>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem'>Sonstiges</Typography>
        </Grid>
        <Grid item xs={5}>
          <IconButton
            size='small'
            onClick={() => {
              setNumberOfOther(numberOfOther + 1);
            }}
          >
            <AddCircleIcon fontSize='large' color='primary' />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container rowSpacing={2} columnSpacing={4} mt={1}>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem'>Bezeichnung</Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography fontSize='0.9rem'>Anzahl</Typography>
        </Grid>
      </Grid>
      <Grid container rowSpacing={2} columnSpacing={4} mt={1} className='fhbf-print-field-text-right'>
        {Array(numberOfOther)
          .fill(0)
          .map((_, index) => (
            <Fragment key={`other_${index}`}>
              <Grid item xs={7}>
                <TextField label='' variant='standard' fullWidth />
              </Grid>
              <Grid item xs={5}>
                <TextField label='' variant='standard' fullWidth />
              </Grid>
            </Fragment>
          ))}
      </Grid>
    </Paper>
  );
}

export default CaseIndependentCooperationWithThePolice;
